import { useLocation } from "react-router-dom";

export const TORONTO_NUMBER = "647-492-1989";
export const DEFAULT_NUMBER = "647-492-1989";

export function useSitePhone() {
  useLocation(); // preserved for API compatibility
  const phone = DEFAULT_NUMBER;
  const phoneLink = `tel:+1${phone.replace(/-/g, "")}`;
  return { phone, phoneLink };
}
